export const ADD_SUCCESS = 'Новая группа клиентов добавлена';
export const ADD_ERROR = 'Не удалось добавить новую группу клиентов';
